exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addFormWrapper {\n  position: fixed;\n  top:0;\n  left:0;\n  right:0;\n  bottom:0;\n  z-index:1110;\n  background-color:#003790;\n  color:white;\n  overflow-y: scroll;\n}\n.addFormWrapper > .row{\n  height: 100%;\n}\n.addForm {\n  position: relative;\n  padding:20px;\n\n}\n.addFormBody {\n\n}\n.hideAddBtn {\n  position: fixed;\n  right:5px;\n  top:5px;\n  z-index: 1110;\n}\n.addFormHeader {\n\n}\nlegend {\n  font-size:.9rem;\n  margin-bottom:.25rem;\n}\nhr {\n  margin-bottom: 8px;\n  margin-top:8px;\n}\n.form-group {\n  margin-bottom:0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/inventory/create.component.css
// module id = 435
// module chunks = 0